import GoldenTicketImg from '../../assets/images/goldenTicket.png'
import {ButtonJoinUs,GoldenTicketSubtitle,GoldenTitle,MainWrapper} from './styles'

const GoldenTicket = () => {
    return (
        <MainWrapper>
            <div style={{ flex: 1 }}>
                <GoldenTitle>The Golden Guests</GoldenTitle>
                <GoldenTicketSubtitle>The Golden Guests edition by the Billionaire Club are the rarest NFTs.<br/>
                    They are all hand drawn and have no element in common with the regular collection.
                </GoldenTicketSubtitle>
                <ButtonJoinUs>
                    Join us to register for the Presale
                </ButtonJoinUs>

            </div>
            <div style={{ flex: 1, width: '25%', objectFit:'fill' }}>
                <img src={GoldenTicketImg} style={{ marginTop: -120 }} />
            </div>
        </MainWrapper>
    )
};
export default GoldenTicket